export default "__VITE_ASSET__Bzd0iOIB__"